import React from 'react';
import styled from 'styled-components';
import { bool, string } from 'prop-types';
import Login from '@airasia/phoenix-widgets/widgets/Login';
import PhoenixTheme from '@airasia/phoenix-components/components/Theme';
import Wrapper from '../Wrapper';
import { PlainCard } from '../Card';
import Row from '../Container/Row';
import Column from '../Container/Column';
import { BodyText, SubBodyText } from '../Text';
import Image from '../Image';
import Button from '../Button';

const StyledPlainCard = styled(PlainCard)`
  padding: 16px 24px;
  margin: 0px 0px 16px 0px;
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  }
`;

const StyledRow = styled(Row)`
  justify-content: space-between;
`;

const StyledColumn = styled(Column)`
  margin-left: 16px;
`;

const StyledButton = styled(Button)`
  margin: auto 0 0 0;

  &:after {
    content: none;
  }

  &:active {
    background-color: white;
  }
`;

const StyledLoginSpan = styled.span`
  padding: 12px 34px;
`;

const ImageURL =
  'https://static.airasia.com/snap/images/Gift%20icon%20%402x.png';

const openByEvent = () => {
  const evt = new CustomEvent('openLogin', {
    detail: true,
  });
  window.dispatchEvent(evt);
};

const PromotionBox = React.memo(function PromotionBox({
  title,
  subtitle,
  loginlabel,
  environment,
  openLoginModalByEvent,
  theme,
  isMoveEnabled,
}) {
  return (
    <StyledPlainCard>
      <StyledRow>
        <Wrapper>
          <Row>
            <Image src={ImageURL} width="40" height="40"></Image>
            <StyledColumn>
              <BodyText>{title}</BodyText>
              <SubBodyText color="greyDark">{subtitle}</SubBodyText>
            </StyledColumn>
          </Row>
        </Wrapper>
        <PhoenixTheme theme={theme}>
          <StyledButton
            big
            secondary
            onClick={openLoginModalByEvent ? openByEvent : undefined}
            border={isMoveEnabled && '#023C40'}
            borderRadius={isMoveEnabled && '32px'}
            hovercolor={isMoveEnabled && '#E8F2EC'}
          >
            {openLoginModalByEvent ? (
              <StyledLoginSpan>{loginlabel}</StyledLoginSpan>
            ) : (
              <Login
                loginLabel={loginlabel}
                environment={environment}
                tooltipdata={[
                  {
                    data: [{}],
                  },
                ]}
                HideAccountCircleIcon={true}
                reloadOnLogin={true}
                shouldShowTooltip={false}
                isScrollTop={false}
                textColor={isMoveEnabled}
                loginText={true}
              />
            )}
          </StyledButton>
        </PhoenixTheme>
      </StyledRow>
    </StyledPlainCard>
  );
});

PromotionBox.propTypes = {
  title: string,
  subtitle: string,
  loginlabel: string,
  environment: string,
  openLoginModalByEvent: bool,
  theme: string,
  isMoveEnabled: bool,
};

PromotionBox.defaultProps = {
  environment: 'staging',
  openLoginModalByEvent: false,
};

export default PromotionBox;
